/* 
FileName:index.js
purpose:Group Chat
Developers:Rohini
 */
import React, { useEffect, useState, useReducer } from 'react';
import SideBar from '../Utility/SideNav';
import Header from '../../Common/TopNav';
import AddGroupChat from '../../Common/GroupChat';
import RootLoader from '../../Common/Loader/RootLoader';
import { useSelector } from 'react-redux';
import { reducer, initialState } from './reducer';
import ChatBox from '../../Common/GroupChat/chat';
import EditGroup from '../../Common/GroupChat/edit_group';
import DeleteGroup from '../../Common/GroupChat/delete_group';
import convertPSTtoLocalTime from '../../Common/convertPSTtoLocalTime';
import { useWebProperties } from '../../Common/webProperties';
import { getEmployees } from '../../Common/GroupChat/Services/getEmployees';
import { createDefaultGroupChat } from './Services/createDefaultGroupChat';
import { getGroupChatDetails } from './Services/getGroupChatDetails';
// import { getAllGroupMessages } from './Services/getAllGroupMessages';
import { getAdminGroup } from './Services/getAdminGroup';
import { getNewAdminGroup } from './Services/getNewAdminGroup';
import { getAllGroupMessages } from './Services/getAllGroupMessages';
import { MESSAGE_REFRESH_TIMER, getEmailDomain } from '../../Common/commonUsage';

export default function GroupChat() {

    const [open, setOpen] = useState({ status: false, index: 0 })
    const getUser = useSelector(state => state.auth)
    const [chatOpen, setChatOpen] = useState(false);
    const [cardInfo, setCardInfo] = useState()
    const [state, dispatch] = useReducer(reducer, initialState)
    const { CHAT_ROOM, CREATE_GROUP, EDIT_GROUP, CHAT, ACTION_ICON, LIMITED_ACCESS_CONTRIBUTOR, role_array, PRODUCT_OWNER, SCRUM_MASTER } = useWebProperties();
    useEffect(() => {
        getGroupChatDetails(dispatch, getUser.user)
        getAllGroupMessages(dispatch, getUser.user);
        getAdminGroup(dispatch, getUser.user);
        getNewAdminGroup(dispatch, getUser.user);
        getEmployees(dispatch, getUser.user)
        // eslint-disable-next-line
    }, [])
    // adding default group 
    const [empList, setEmpList] = useState([]);
    // eslint-disable-next-line
    const [productOwner, setProductOwner] = useState([])
    const [searchWord, setSearchWord] = useState('')
    const [archiveFilter, setArchiveFilter] = useState(false)

    useEffect(() => {
        const fetchUserStoryMessages = () => {
            // getAllGroupMessages(dispatch, getUser.user);
        };

        // Function to fetch messages and schedule the next fetch after 10 seconds
        const fetchDataAndScheduleNext = () => {
            fetchUserStoryMessages();
            setTimeout(fetchDataAndScheduleNext, MESSAGE_REFRESH_TIMER); // Schedule next fetch after 10 seconds
        };

        // Initial fetch when component mounts
        fetchUserStoryMessages();

        // Schedule the next fetch after 10 seconds
        const timerId = setTimeout(fetchDataAndScheduleNext, MESSAGE_REFRESH_TIMER);

        // Clean up the timer on component unmount
        return () => clearTimeout(timerId);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (state.employees.length > 0) {
            setProductOwner(state.employees.filter(empp => empp.workingStatus === "Active" && (empp.role === 'Product Owner' || "Scrum Master")).map((emp) => {
                return emp
            }))
            setEmpList(state.employees.filter(empp => empp.workingStatus === "Active" && empp.id !== getUser.user.empId).map((emp) => {
                return { 'value': emp.email, 'label': emp.name, 'data': emp }
            }))
        }
        // eslint-disable-next-line
    }, [state.employees])


    useEffect(() => {
        if (state.details.every(item => item.group_name !== getUser.user.corp)) {
            createDefaultGroupChat(
                state,
                empList.map(x => x.label).toString(),
                empList.map(x => x.value).toString(),
                dispatch,
                getUser.user,
                handleClose
            );
        }        // eslint-disable-next-line
    }, [state.details])

    // console.log("admin",state.adminGroupsMsg)
    // getting list of group name (i.e. unique) with last message and time
    const key = 'id';
    const arrayUniqueByKey = [...new Map(state.adminGroupsMsg.map(item =>
        [item[key], item])).values()].sort((a, b) => b.sno - a.sno);
    // const events = [...state.adminGroups, ...state.details ]
    // console.log("arrayUniqueByKey",arrayUniqueByKey)

    // display groups who have unread messages on top  
    const sortedOne = (msg, emp, empId) => {
        const sortedUserIds = msg
            .sort()
            .filter(m => m.groupId !== null && m.readBy.split(",").indexOf(empId) === -1 && m.messagedBy !== empId)
            .map(m => m.groupId)

        const sortedUsers = [...new Set(sortedUserIds)].map(id => emp.find(u => u.id === id))
        const sorted = sortedUsers.filter(id => id !== undefined)

        const namesToDeleteSet = new Set(sorted);

        const newArr = emp.filter((employee) => {
            return !namesToDeleteSet.has(employee);
        });
        const sortedEmployees = sorted.concat(newArr)
        return sortedEmployees;

    }
    const handleOpen = (action, data) => {
        var info;
        setOpen({ status: true, action: action });
        if (action === "modify") {
            // var status = "backlog_addUser"
            info = { data: data }
        } else if (action === "delete") {
            // var status = "backlog_addUser"
            info = { data: data, action: action }
        } else if (action === "exit") {
            // var status = "backlog_addUser"
            info = { data: data, action: action }
        } else if (action === "archive") {
            // var status = "backlog_addUser"
            info = { data: data, action: action }
        } else if (action === "reopen") {
            // var status = "backlog_addUser"
            info = { data: data, action: action }
        }
        setCardInfo(info)
    }

    const handleClose = () => {
        setOpen({ status: false, index: 0 })
        getGroupChatDetails(dispatch, getUser.user)
        getAdminGroup(dispatch, getUser.user);
        getNewAdminGroup(dispatch, getUser.user);
    };

    const handleModalClose = () => {
        setOpen({ status: false, index: 0 });
        getGroupChatDetails(dispatch, getUser.user)
        getAdminGroup(dispatch, getUser.user);
        getNewAdminGroup(dispatch, getUser.user);
    }

    const handleOpenChat = (id, sno, name) => {
        setChatOpen(true);
        // updateChat(sno,dispatch,getUser.user)
        var info = { id: id, sno: sno, name: name };
        setCardInfo(info);
    };

    const handleChatClose = () => {
        setChatOpen(false);
        getGroupChatDetails(dispatch, getUser.user)
        getAdminGroup(dispatch, getUser.user);
        getAllGroupMessages(dispatch, getUser.user);
        getNewAdminGroup(dispatch, getUser.user);
    };

    //   const getLastMsg = (message, id) =>{
    //       const groupMsg =  message.filter(msg => msg.groupId === id).map((mg, i ) =>{
    //           return mg.message
    //       });
    //       return groupMsg[groupMsg.length-1]
    //   }
    //   const getLastMsgTime = (message, id) =>{
    //     const groupMsg =  message.filter(msg => msg.groupId === id).map((mg, i ) =>{
    //         return  mg.messaged_time
    //     });
    //     return groupMsg[groupMsg.length-1]
    // }
    // const getLastMsgSendBy = (message, id) =>{
    //     const groupMsg =  message.filter(msg => msg.groupId === id).map((mg, i ) =>{
    //         return mg.fullname
    //     });
    //     return groupMsg[groupMsg.length-1]
    // }
    //   console.log("msg",getLastMsg(state.allMessages,'76'))
    //   console.log("msg",state.allMessages)

    // for getting message unread message count
    const getMessagesCount = (id, msg, empId, name) => {

        const msgCount = msg.filter(message => message.readBy.split(",").indexOf(empId) === -1 && message.messagedBy !== empId && message.groupId === id).map((messages, i) => {
            // eslint-disable-next-line
            return i, messages
        })
        return (
            <i>
                {
                    msgCount.length > 0 ?
                        <div className="row">
                            <img src="images/common/chat.svg" title={CHAT} alt="logo" style={{ width: '20px', height: '20px', marginLeft: "-5px" }}
                                onClick={(event) => handleOpenChat(id, msgCount, name)} />
                            <span style={{ color: 'red', fontWeight: "bold" }}>{msgCount.length > 9 ? "9+" : msgCount.length}</span>
                        </div>
                        :
                        <div className="row">
                            <img src="images/common/chat.svg" title={CHAT} alt="logo" style={{ width: '20px', height: '20px', marginLeft: "-5px" }}
                                onClick={(event) => handleOpenChat(id, msgCount, name)} />
                        </div>
                }
            </i>
        )
    }
    return (
        <div className="container-scroller">
            <Header />
            <div className="container-fluid page-body-wrapper">
                <SideBar />
                <div className="main-panel">
                    <div className="mt-2">
                        {
                            role_array[getUser.user.role] === LIMITED_ACCESS_CONTRIBUTOR && getEmailDomain(getUser.user.userName) !== 'novisync.com' ?
                                <div></div>
                                :
                                <div className="col-lg-12 grid-margin stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <div>
                                                <h2 className="card-title" style={{ overflowWrap: "break-word", color: 'blue', backgroundColor: 'transparent' }}>{CHAT_ROOM}</h2>
                                            </div>

                                            <div className="d-flex justify-content-end mb-2 " >
                                                <div style={{ flexDirection: 'column' }}>
                                                    <div className="d-flex justify-content-end mb-3 mt-2">
                                                        <div class="input-group-prepend">
                                                            <span class="text" style={{ color: 'black', marginTop: '3px', fontSize: '13px', paddingRight: 10 }}>Search: </span>
                                                        </div>
                                                        <input type="text" class="form-control" style={{ backgroundColor: 'transparent', borderBottom: '2px solid black', borderTop: '2px solid black', borderLeft: '12x solid black', borderRight: '2px solid black', marginTop: '-5px', width: 250, height: '35px' }}
                                                            value={searchWord}
                                                            onChange={(event) => setSearchWord(event.target.value)}
                                                        />
                                                    </div>
                                                    <div className='group-add' style={{ marginLeft: 380 }}>
                                                        <button style={{ backgroundColor: 'transparent', border: '0' }} type="button"
                                                            onClick={() => setArchiveFilter(!archiveFilter)}
                                                        > <img src="images/common/chat-3.png" alt="logo" title={"Archived group chats"} style={{ width: '20px', height: '20px' }} /><span className="m-1">{" "}{archiveFilter ? "Normal" : "Archived"}</span></button>
                                                        <button style={{ backgroundColor: 'transparent', border: '0' }} type="button"
                                                            onClick={() => handleOpen("add")}
                                                        > <img src="images/common/add.png" alt="logo" title={CREATE_GROUP} style={{ width: '20px', height: '20px' }} /><span className="m-1">{CREATE_GROUP}</span></button>
                                                        {
                                                            open.action === "add" ? <AddGroupChat open={open.status} handleClose={handleClose}
                                                                // data={cardInfo}
                                                                handleModalClose={handleModalClose}
                                                            /> : null
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                            {/* start  */}
                                            {state.isLoading ? <RootLoader /> :
                                                <div className='arc'>
                                                    {state.details.length > 0 ?
                                                        state.details.filter((val) => {
                                                            if (searchWord === "") {
                                                                return val
                                                            } else if (val.group_name.toLowerCase().includes(searchWord.toLowerCase())) {
                                                                return val
                                                            } else {
                                                                return ""
                                                            }
                                                        }).filter((val) => {
                                                            return (val.is_archived === (archiveFilter === true ? "true" : 'false'))
                                                        }).map((group, index) => {
                                                            return (
                                                                <div className="" key={group.id}>
                                                                    <div className="card">
                                                                        <div className="col-12 row p-2" style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <div className="col-11 row hcn">
                                                                                <div className='col-2'>
                                                                                    <label style={{ margin: '20px', cursor: 'pointer' }} title={group.members_name}>{group.group_name}</label>
                                                                                </div>
                                                                                {group.messaged_time !== null ?
                                                                                    <div className='col-10'>
                                                                                        <label className='mr-2' style={{ color: "green", }}> {group.fullname}</label>
                                                                                        <label className='mr-2 cht' style={{
                                                                                            color: 'gray', whiteSpace: 'nowrap',
                                                                                            overflow: 'hidden',
                                                                                            textOverflow: 'ellipsis',
                                                                                            width: '100%'
                                                                                        }}
                                                                                        >
                                                                                            {sortedOne(state.allMessages, arrayUniqueByKey, getUser.user.empId).filter(x => {
                                                                                                return x.id === group.id
                                                                                            }).map(y => {
                                                                                                return <div  >
                                                                                                    <label style={{ color: "green" }} className='mr-2'> {y.fullname}</label>
                                                                                                    <label className='mr-2' style={{ color: 'gray' }}
                                                                                                    > <div style={{ color: y.is_deleted === "true" ? 'grey' : 'black' }} dangerouslySetInnerHTML={{ __html: y.is_deleted === "true" ? "Messaged deleted" : y.message }} />
                                                                                                    </label>
                                                                                                    <label className='mr-2' style={{ color: 'grey' }}>
                                                                                                        {convertPSTtoLocalTime(y.messaged_time)}</label>
                                                                                                </div>
                                                                                            })}
                                                                                        </label>
                                                                                        <label className='mr-2' style={{ color: 'grey' }}>
                                                                                            {convertPSTtoLocalTime(group.messaged_time)}</label>

                                                                                    </div> : ""}

                                                                            </div>
                                                                            <div className='col-1' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                                                                {
                                                                                    group.is_archived !== 'true' ?
                                                                                        <button type="button" style={{ backgroundColor: 'transparent', border: "0" }} >
                                                                                            {
                                                                                                getMessagesCount(group.id, state.allMessages, getUser.user.empId, group.group_name)
                                                                                            }
                                                                                        </button>
                                                                                        :
                                                                                        <label style={{ margin: '20px', cursor: 'pointer', background: '#efab73', padding: '10px', borderRadius: '10px' }} title={"Archived"}>Archived</label>
                                                                                }

                                                                                <div className="" style={{ cursor: 'pointer' }}>
                                                                                    {/* eslint-disable-next-line */}
                                                                                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-expanded="false">
                                                                                        <img src="images/common/actionmenu.png" title={ACTION_ICON} alt="logo" style={{ width: '15px', height: '15px', borderRadius: '0' }} />
                                                                                    </a>
                                                                                    <div className="dropdown-menu" labelled="dropdownMenuLink" style={{ backgroundColor: 'transparent', border: '0' }}>
                                                                                        {
                                                                                            group.is_archived === 'true' ?
                                                                                                <div>
                                                                                                    {
                                                                                                        (group.created_by === getUser.user.userName) ||
                                                                                                            (role_array[getUser.user.role] === PRODUCT_OWNER || role_array[getUser.user.role] === SCRUM_MASTER)
                                                                                                            ?

                                                                                                            <button className="dropdown-item badge badge-pill badge-warning text-center" style={{ backgroundColor: "#76C54E", color: 'white' }}
                                                                                                                onClick={() => handleOpen("reopen", group)}
                                                                                                            >Reopen</button>
                                                                                                            :
                                                                                                            ""
                                                                                                    }
                                                                                                </div>
                                                                                                :
                                                                                                <div className='ml-n3'>
                                                                                                    <button className=" badge badge-pill badge-warning text-center" style={{ backgroundColor: "#203B5A", color: 'white', width: '120px' }}
                                                                                                        onClick={() => handleOpen("exit", group)}
                                                                                                    >Exit</button>
                                                                                                    {
                                                                                                        (group.created_by === getUser.user.userName && group.group_name !== getUser.user.corp) ||
                                                                                                            (role_array[getUser.user.role] === PRODUCT_OWNER || role_array[getUser.user.role] === SCRUM_MASTER)
                                                                                                            ?
                                                                                                            <>
                                                                                                                <button className="dropdown-item badge badge-pill badge-warning text-center" style={{ backgroundColor: "#76C54E", color: 'white', width: '120px' }}
                                                                                                                    onClick={() => handleOpen("modify", group)}
                                                                                                                >{EDIT_GROUP}</button>
                                                                                                                <button className="dropdown-item badge badge-pill badge-warning text-center" style={{ backgroundColor: "#efab73", color: 'white', width: '120px' }}
                                                                                                                    onClick={() => handleOpen("archive", group)}
                                                                                                                >Archive</button>
                                                                                                                {
                                                                                                                    group.group_name !== getUser.user.corp ?


                                                                                                                        <button className="dropdown-item badge badge-pill badge-warning text-center" style={{ backgroundColor: "rgb(99, 4, 54)", color: 'white', width: '120px' }}
                                                                                                                            onClick={() => handleOpen("delete", group)}
                                                                                                                        >Delete</button>
                                                                                                                        :
                                                                                                                        null
                                                                                                                }
                                                                                                            </>
                                                                                                            :
                                                                                                            null
                                                                                                    }

                                                                                                </div>
                                                                                        }
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            )
                                                        }) : null}

                                                    {chatOpen ? (
                                                        <ChatBox
                                                            open={chatOpen}
                                                            handleClose={handleChatClose}
                                                            data={cardInfo}
                                                            handleModalClose={handleChatClose}
                                                        />
                                                    ) : null}
                                                    {
                                                        open.action === "modify" ?
                                                            <EditGroup open={open.status}
                                                                handleClose={handleClose}
                                                                data={cardInfo}
                                                                handleModalClose={handleModalClose}
                                                            /> : null}
                                                    {
                                                        open.action === "delete" || open.action === "exit" || open.action === 'archive' || open.action === 'reopen' ?
                                                            <DeleteGroup open={open.status}
                                                                handleClose={handleClose}
                                                                data={cardInfo}
                                                                handleModalClose={handleModalClose}
                                                            /> : null}
                                                </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                        }

                    </div>
                </div>
            </div>
        </div>

    )
}